
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/fr/en/faq",
      function () {
        return require("private-next-pages/fr/en/faq.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/fr/en/faq"])
      });
    }
  